import { ModelTimeline } from './summary/model-timeline';
export class SchedulerTaskSubTask {
  public formatedModelTimeLines: any;
  constructor(
    public hash: string,
    public identifier: string,
    public current: boolean,
    public running: boolean,
    public sent: boolean,
    public sendDate: number,
    public programsDuration: number,
    public isVersioned: boolean,
    public modelTimelines: ModelTimeline[]
  ) {}
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/scheduler-task-sub-task.ts